import config from './config'
import { getData, setData } from './auth'

const getAuthToken = async () => {
    var token = getData("AccessToken");
    // console.log(token)
    if(token===null || token===""){
        const response = await fetch(config.apiUrl+"generate_token", {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });

        if (!response.ok) throw new Error("Auth Token Generation failed");
        const resp = await response.json();
        if(resp.apiStatus){
            setData("AccessToken",resp.token);
            token = getData("AccessToken");
        } else {
            throw new Error("API Error: "+resp.message);
        }
    }
    //console.log(token)
    return token;
};

const Api = {
    sendMail : async (param) => {
        const key = await getAuthToken();
        console.log(param)
        const response = await fetch(config.apiUrl+"send_mail", {
            method: "POST",
            headers: { "Authorization": key },
            body: param
        });

        if (!response.ok) throw new Error("Send Mail Failed");
        const resp = await response.json();
        if(resp.apiStatus){
            return true;
        } else {
            throw new Error("API Error: "+resp.message);
        }
    }
};

export default Api;